// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.7 7.7L21 12L16.7 16.3L16 15.6L19 12.5L9.8 12.5L9.8 11.5L19.1 11.5L16 8.4L16.7 7.7ZM4.50019 20L12.0002 20L12.0002 21L4.50019 21C3.67177 21 3.00019 20.3284 3.00019 19.5L3.00019 4.5C3.00019 3.67157 3.67177 3 4.50019 3L12.0002 3L12.0002 4L4.50019 4C4.22405 4 4.00019 4.22386 4.00019 4.5L4.00019 19.5C4.00019 19.7761 4.22405 20 4.50019 20Z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-logout-CwWjiFyD.js.map
